module.exports = __webpack_public_path__ + "img/vehicle-options-black-chevy.5b137df0.png";